'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'signs-post';
var width = 512;
var height = 512;
var aliases = ["map-signs"];
var unicode = 'f277';
var svgPathData = ['M224.4 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32-64 0 0-32zm0 160l64 0 0 64-64 0 0-64zm0 192l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z', 'M64.4 64l377.4 0c4.2 0 8.3 1.7 11.3 4.7l48 48c6.2 6.2 6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7L64.4 192c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm384 192c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L71 384c-4.2 0-8.3-1.7-11.3-4.7l-48-48c-6.2-6.2-6.2-16.4 0-22.6l48-48c3-3 7.1-4.7 11.3-4.7l377.4 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignsPost = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;